// Firmowe/Prywatne
export const realEstatesCorporatePrivate = (state = false, action) => { 
    switch (action.type) {
        case 'REAL_ESTATES_CORPORATE_PRIVATE_CHANGE':
            return action.value;      
        default:
            return state
    }
}

// Hipoteka obciążona
export const realEstatesMortgageEncumbered = (state = false, action) => { 
    switch (action.type) {
        case 'REAL_ESTATES_MORTGAGE_ENCUMBERED_CHANGE':
            return action.value;      
        default:
            return state
    }
}

// Własność
export const realEstatesOwnership = (state = false, action) => { 
    switch (action.type) {
        case 'REAL_ESTATES_OWNERSHIP_CHANGE':
            return action.value;      
        default:
            return state
    }
}

// Zaległości podatkowe
export const realEstatesFiles = (state = [], action) => { 
    switch (action.type) {
        case 'REAL_ESTATES_FILES_CHANGE':
            return action.value;      
        default:
            return state
    }
}

// Zaległości podatkowe itemy

export const realEstatesItems = (state = [], action) => { 
    switch (action.type) {
        case 'REAL_ESTATES_ITEMS_CHANGE':
            return action.value;      
        default:
            return state
    }
}

// Posiadane środki trwałe

export const fundsFiles = (state = [], action) => { 
    switch (action.type) {
        case 'FUNDS_FILES_CHANGE':
            return action.value;      
        default:
            return state
    }
}

// Posiadane środki trwałe itemy

export const fundsItems = (state = [], action) => { 
    switch (action.type) {
        case 'FUNDS_ITEMS_CHANGE':
            return action.value;      
        default:
            return state
    }
}

// new

export const shareCapital = (state = "", action) => { 
    switch (action.type) {
        case 'SHARE_CAPITAL_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const legalForm = (state = false, action) => { 
    switch (action.type) {
        case 'LEGAL_FORM_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const lineBusiness = (state = [], action) => { 
    switch (action.type) {
        case 'LINE_BUSINESS_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const revenuePresentFinancialYear = (state = [], action) => { 
    switch (action.type) {
        case 'REVENUE_PRESENT_FINANCIAL_YEAR_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const revenueLastFinancialYear = (state = [], action) => { 
    switch (action.type) {
        case 'REVENUE_LAST_FINANCIAL_YEAR_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const financialCity = (state = [], action) => { 
    switch (action.type) {
        case 'FINANCIAL_CITY_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const financialAddress = (state = [], action) => { 
    switch (action.type) {
        case 'FINANCIAL_ADDRESS_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const bankCompanyName = (state = [], action) => { 
    switch (action.type) {
        case 'BANK_COMPANY_NAME_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const bankName = (state = [], action) => { 
    switch (action.type) {
        case 'BANK_NAME_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const bankIban = (state = [], action) => { 
    switch (action.type) {
        case 'BANK_IBAN_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const bankEmail = (state = [], action) => { 
    switch (action.type) {
        case 'BANK_EMAIL_CHANGE':
            return action.value;      
        default:
            return state
    }
}


export const trn = (state = [], action) => { 
    switch (action.type) {
        case 'TRN_CHANGE':
            return action.value;      
        default:
            return state
    }
}